import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { AuthShell } from '../components/auth-shell';
import { usePageTitle } from '../lib/page-title';

export function SignUpPage() {
  usePageTitle('Create account');
  const { auth } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState<string | null>(null);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage(null);
    const { error } = await auth.signUp({
      email,
      password,
      options: { emailRedirectTo: `${window.location.origin}/auth/callback` },
    });
    setSubmitting(false);
    if (error) {
      setErrorMessage(error.message);
      return;
    }
    setSubmittedEmail(email);
  }

  if (submittedEmail) {
    return (
      <AuthShell>
        <h1>Check your inbox</h1>
        <p role="status">
          We sent a confirmation link to {submittedEmail}. Follow it to finish creating your
          account.
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1>Create your account</h1>
      <p>
        Free includes AAPL, NVDA, and GOOGL, no card needed. Use at least 12 characters for your
        password.
      </p>
      <form className="auth-form" onSubmit={(event) => void submit(event)}>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {errorMessage ? (
          <p className="form-error" role="alert">
            {errorMessage}
          </p>
        ) : null}
        <button type="submit" disabled={submitting}>
          {submitting ? 'Creating account…' : 'Create account'}
        </button>
      </form>
      <div className="auth-links">
        <p>
          Already registered?{' '}
          <Link className="text-link" to="/signin">
            Sign in
          </Link>
        </p>
      </div>
    </AuthShell>
  );
}
